import React from "react";

const ClientAccessLabel = ({ access }: { access: server.dto.ClientAccess }) => {
  return (<div className="flex padding" style={{
    backgroundColor: access.hexColor,
    color: "white",
    display: "inline-block"
  }}>{access.text}</div>);
};

export default ClientAccessLabel;